
import ButtonBase from '~/components/Buttons/ButtonRound/ButtonBase'
import ButtonRound from '~/components/Buttons/ButtonRound'
export default {
  name: 'ButtonRoundGreen',
  components: { ButtonRound },
  extends: ButtonBase,
}
